"use client";

import type { FC } from "react";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks } from "@builder.io/sdk-react";

import { BlogArticle as UIBlogArticle } from "@jti/ui/components/BlogArticle";

import type { blogArticleInputs } from "@/components/BlogArticle/BlogArticle.builder";

import { BlogRelatedArticles } from "../BlogRelatedArticles/BlogRelatedArticles";

export type BlogArticleBuilderProps = BuilderComponentProps<typeof blogArticleInputs> & {
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export const BlogArticle: FC<BlogArticleBuilderProps> = ({
  title,
  subtitle,
  image,
  creationDate,
  author,
  showAuthor,
  relatedArticles,
  relatedArticlesTitle,
  relatedArticlesCtaLabel,
  relatedArticlesCtaUrl,
  readTime,
  builderBlock,
  builderContext,
  builderComponents,
}) => {
  return (
    <>
      <UIBlogArticle
        title={title}
        topicName={subtitle}
        creationDate={creationDate}
        mainImage={image || null}
        author={author}
        showAuthor={showAuthor}
        readTime={readTime}
      >
        {builderBlock?.children?.map((child) => (
          <Blocks
            key={child.id}
            blocks={[child]}
            parent={builderBlock?.id}
            path="children"
            context={builderContext}
            registeredComponents={builderComponents}
          />
        ))}
      </UIBlogArticle>
      {relatedArticles && relatedArticles.length > 0 && (
        <BlogRelatedArticles
          relatedArticlesTitle={relatedArticlesTitle}
          relatedArticlesCtaLabel={relatedArticlesCtaLabel}
          relatedArticlesCtaUrl={relatedArticlesCtaUrl}
          relatedArticles={relatedArticles}
        />
      )}
    </>
  );
};
